export const getPremiumUpsellIconClasses = (): string => {
  return 'icon-crown icon -premium-color';
};
